/**
 * personas.service.js
 *
 * Servicio de búsqueda de personas por CUIL.
 * Delega la consulta al backend, que a su vez consulta la API de CIDI.
 *
 * Endpoint: GET /notas-autorizacion-nuevo/personas/cuil/:cuil
 */
import apiClient from './apiClient';

const URL = process.env.REACT_APP_API_URL + "/notas-autorizacion-nuevo/personas/cuil";

export const buscarPersonaPorCuil = async (cuil) => {
  try {
    const response = await apiClient(`${URL}/${cuil}`, {
      method: 'GET',
    });

    if (response.status === 404) {
      return {
        success: false,
        message: 'Persona no encontrada.',
      };
    }

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      return {
        success: false,
        message: errorData?.message || `Error del servidor (${response.status})`,
      };
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    return {
      success: false,
      message: 'No se pudo conectar con el servidor. Verifique su conexión.',
    };
  }
};
